import {styled} from '@mui/material';

const Img = styled('img')({});

export default Img;


